/**
 * Recently viewed products slider initialization
 * Depends on: product-slider-chevrons.js
 */
(function() {
  const SELECTOR = '[data-recently-viewed-slider]';
  
  const initRecentlyViewedSliders = () => {
    if (!window.ProductSliderChevrons) return;
    
    const containers = document.querySelectorAll(`recently-viewed-products ${SELECTOR}`);
    containers.forEach(container => {
      const sliderWrapper = container.querySelector('.tabbed-product-slider__slider-wrapper');
      if (sliderWrapper) {
        window.ProductSliderChevrons.init(sliderWrapper, { initHorizontalSlider: true });
      }
    });
  };
  
  // Run initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecentlyViewedSliders);
  } else {
    initRecentlyViewedSliders();
  }
  
  // Also run after a delay to ensure horizontal slider script has loaded
  setTimeout(initRecentlyViewedSliders, 150);
  
  // Handle dynamically loaded content
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          const container = node.querySelector ? node.querySelector(SELECTOR) : null;
          const isContainer = node.dataset && node.dataset.recentlyViewedSlider;
          
          if (container || isContainer) {
            setTimeout(initRecentlyViewedSliders, 300);
          }
        }
      });
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Handle Shopify theme editor
  document.addEventListener('shopify:section:load', event => {
    const container = event.target.querySelector(SELECTOR);
    if (container) {
      const sliderWrapper = container.querySelector('.tabbed-product-slider__slider-wrapper');
      if (sliderWrapper) {
        sliderWrapper.dataset.chevronsInitialized = 'false';
        setTimeout(() => {
          window.ProductSliderChevrons?.init(sliderWrapper, { initHorizontalSlider: true });
        }, 100);
      }
    }
  });
})();